import API from '@/views/Fdc/Apis/'

/**
 * Event Save Modal Component
 * Event 정보를 저장하는 component
 */
export default {
  name: 'eventSaveModal',
  /**
   * Modal 표시 여부
   * @param {Boolean} visible
   *
   * Modal 초기 data
   * @param {Object} initValue
   *
   * Save Method 실행 여부
   * @param {Boolean} saveReady
   *
   * Save 종료 시 실행 method
   * @param {Function} saveComplete
   *
   * Save 취소 시 실행 method
   * @param {Function} cancelSave
  */
  props: [
    'visible',
    'initValue',
    'saveReady',
    'saveComplete',
    'cancelSave'
  ],
  watch: {
    /**
     * Modal 표시 여부 감지
     * 초기 data를 설정합니다.
     */
    visible () {
      this.initData()
    },
    /**
     * saveReady 변화 감지
     * @param {Boolean} value 저장 실행 여부
     * saveReady가 true일 때 saveData method를 실행합니다.
     */
    saveReady (value) {
      if (value) {
        this.saveData()
      }
    }
  },
  beforeMount () {
    this.initData()
    this.getCodeList('eventType')
  },
  methods: {
    /**
     * Event 저장
     */
    async saveData () {
      let self = this

      let mustSaveRows = [{
        fab: this.fab,
        eqpId: this.eqpId,
        moduleId: this.moduleId,
        ceid: this.ceid,
        eventType: this.eventType,
        eventName: this.eventName,
        eventDesc: this.eventDesc,
        startYn: this.startYn,
        virtualYn: this.virtualYn,
        useYn: this.useYn
      }]

      if (!this.saveValidation(mustSaveRows)) {
        this.cancelSave()
        return
      }

      let message = this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')

      this.$dialog.confirm({
        message: message,
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        onConfirm: function () {
          function saveLastProcess (response) {
            if (response != null && response.status === 200) {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE'))
              self.resetData()
              self.saveComplete()
            } else {
              self.$dialog.alert(self.$t('fdc.COMMON.MESSAGE.FAILED_SAVE'))
            }
          }

          if (mustSaveRows.length > 0) {
            API.BaseInfo.addEqpEvent(mustSaveRows).then(result => {
              saveLastProcess(result)
            })
          }
        },
        onCancel: function () {
          self.cancelSave()
        }
      })
    },
    /**
     * Event Save Validation
     * @param {Array} rows save data 배열
     * @returns {Boolean} validation 성공 여부
     */
    saveValidation (rows) {
      for (let i in rows) {
        if (!rows[i].eqpId || rows[i].eqpId.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Eqp ID']))
          return false
        } else if (!rows[i].moduleId || rows[i].moduleId.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Module ID']))
          return false
        } else if (!rows[i].ceid || rows[i].ceid.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Ceid']))
          return false
        } else if (!rows[i].eventType || rows[i].eventType.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Event Type']))
          return false
        } else if (!rows[i].eventName || rows[i].eventName.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Event Name']))
          return false
        } else if (!rows[i].useYn || rows[i].useYn.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Usable']))
          return false
        } else if (!rows[i].startYn || rows[i].startYn.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Start Event']))
          return false
        } else if (!rows[i].virtualYn || rows[i].virtualYn.trim() === '') {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', ['Virtual']))
          return false
        }
        let isNotEventType = true
        for (let j in this.eventTypeList) {
          if (rows[i].eventType === this.eventTypeList[j]) {
            isNotEventType = false
          }
        }
        if (isNotEventType) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Event Type']))
          return false
        }
        let isNotUseYn = true
        for (let j in this.useYnList) {
          if (rows[i].useYn === this.useYnList[j].useYn) {
            isNotUseYn = false
          }
        }
        if (isNotUseYn) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Usable']))
          return false
        }
        let isNotStartYn = true
        for (let j in this.startYnList) {
          if (rows[i].startYn === this.startYnList[j].startYn) {
            isNotStartYn = false
          }
        }
        if (isNotStartYn) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Start Event']))
          return false
        }
        let isNotVirtualYn = true
        for (let j in this.virtualYnList) {
          if (rows[i].virtualYn === this.virtualYnList[j].virtualYn) {
            isNotVirtualYn = false
          }
        }
        if (isNotVirtualYn) {
          this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_VALID', ['Virtual']))
          return false
        }
      }
      return true
    },
    /**
     * 초기 Data 설정
     */
    initData () {
      if (this.visible) {
        this.fab = this.initValue.fab
        this.eqpId = this.initValue.eqpId
        this.moduleId = this.initValue.moduleId

        if (this.initValue.saveType === 'Add') {
          this.useYn = 'Y'
          this.startYn = 'Y'
          this.virtualYn = 'N'
        } else if (this.initValue.saveType === 'Edit') {
          this.ceid = this.initValue.ceid
          this.eventType = this.initValue.eventType
          this.eventName = this.initValue.eventName
          this.eventDesc = this.initValue.eventDesc
          this.useYn = this.initValue.useYn
          this.startYn = this.initValue.startYn
          this.virtualYn = this.initValue.virtualYn
        }
      }
    },
    /**
     * Data 초기화
     */
    resetData () {
      this.fab = null
      this.eqpId = null
      this.moduleId = null
      this.ceid = null
      this.eventType = null
      this.eventName = null
      this.eventDesc = null
      this.useYn = null
      this.startYn = null
      this.virtualYn = null
    },
    /**
     * Code 목록 조회
     * @param {String} type code type
     * Event Type 목록을 조회합니다.
     */
    async getCodeList (type) {
      var payload = {
        codeType: type
      }
      var data = await API.Common.getCodesString(payload)
      if (type === 'eventType') {
        this.eventTypeList = data
      }
    },
    /**
     * Event Type Combobox change method
     * START event 일 경우 startYn을 'Y'로, END event 일 경우 startYn을 'N'으로 자동 변경합니다.
     */
    changeEventType () {
      const temp = this.eventType.split('_')[1]

      if (temp) {
        const startOrEnd = temp.toUpperCase()

        if (startOrEnd === 'START') {
          this.startYn = 'Y'
        } else if (startOrEnd === 'END') {
          this.startYn = 'N'
        }
      }
    }
  },
  data () {
    return {
      fab: null, // Fab data
      eqpId: null, // EQP ID data
      moduleId: null, // Module ID data
      ceid: null, // CEID data
      eventDesc: null, // Event discription data
      eventName: null, // Event Name data
      eventType: null, // Event type data
      startYn: null, // Start YN data
      virtualYn: null, // Virtual YN data
      useYn: null, // Use YN data
      eventTypeList: [], // Event Type 배열
      startYnList: [
        { startYn: 'Y' },
        { startYn: 'N' }
      ], // Start YN combobox 배열
      virtualYnList: [
        { virtualYn: 'Y' },
        { virtualYn: 'N' }
      ], // Virtual YN combobox 배열
      useYnList: [
        { useYn: 'Y' },
        { useYn: 'N' }
      ] // Use YN combobox 배열
    }
  }
}
